import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {

  host = "https://csci-571-homework-8-ritesh.wl.r.appspot.com";

  constructor(private httpClient:HttpClient) { }

  getTickerSummary(ticker):Observable<any[]> {
    return this.httpClient.get<any[]>(this.host+"/api/details/summary/"+ticker);
  }

  getTickerNews(ticker):Observable<any[]> {
    return this.httpClient.get<any[]>(this.host+"/api/details/news/"+ticker);
  }

  getTickerCharts(ticker):Observable<any[]> {
    return this.httpClient.get<any[]>(this.host+"/api/details/charts/"+ticker);
  }
}
